// assets/countup.js

document.addEventListener('DOMContentLoaded', function () {
  const countupElements = document.querySelectorAll('.countup');
  const totalDuration = 3000; // Total duration of the count-up in milliseconds

  // Function to start the count-up animation
  const startCountup = (el) => {
    const target = parseInt(el.getAttribute('data-target'), 10); // Parse target as integer
    const timeFraction = parseFloat(el.getAttribute('data-time-fraction')); // Get the time fraction
    const duration = totalDuration * timeFraction; // Calculate duration for this element
    const step = target / (duration / 20); // Calculate step size
    let count = 0;
    let elapsed = 0; // Track elapsed time

    const updateCount = () => {
      count += step;
      elapsed += 20; // Increment elapsed time

      if (elapsed < duration) {
        el.innerText = Math.floor(Math.min(count, target)); // Display as integer
        setTimeout(updateCount, 20); // Update every 20ms
      } else {
        el.innerText = target; // Ensure it ends at the exact target
      }
    };

    updateCount();
  };

  // Function to handle the intersection event
  const onIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        startCountup(element); // Start the animation
        observer.unobserve(element); // Stop observing once animation starts
      }
    });
  };

  // Set up the IntersectionObserver
  const observerOptions = {
    threshold: 0.1 // Adjust this value to control when the animation starts
  };

  const observer = new IntersectionObserver(onIntersection, observerOptions);

  // Observe each countup element
  countupElements.forEach(el => {
    observer.observe(el);
  });
});
